import { IAppState } from '../../store';

export const selectName = (state: IAppState) => state.personalLeadsForm.data.name;
